import { cloneDeep } from 'lodash';

export default function mapOTtoDemandeSuiviProductionOT(OT) {
  const newOT = cloneDeep(OT);
  newOT.otEtat = newOT.etat;
  return newOT;
}
